import React from "react";
import moment from "moment";
import { FormattedMessage } from "react-intl";

export const getDayString = (idate) => {
    const date = moment(idate);
    const yesterday = moment().add(-1, "day").endOf("day");
    const today = moment().endOf("day");
    const tomorrow = moment().add(1, "day").endOf("day");

    if (date > yesterday && date <= today)
        return <FormattedMessage id="tech.job.today-label" defaultMessage="Today" description="Tech job today label" />;
    if (date > today && date < tomorrow)
        return <FormattedMessage id="tech.job.tomorrow-label" defaultMessage="Tomorrow" description="Tech job tomorrow label" />;
    return moment(idate).format("MMM DD, YYYY");
};

export const getTimeRange = (idate, duration) => {
    const date = moment.tz(idate, moment.tz.guess());
    let formatedString = date.format("LT");
    return formatedString + " - " + date.add(duration, "seconds").format("LT");
};

export const getTimeRangeBtw = (idate, duration) => {
    if (!idate || !duration) return "";
    const date = idate._isAMomentObject ? moment.utc(idate).local() : moment.utc(Date.parse(idate.slice(0, 19))).local();
    let formatedString = date.format("LT");
    return formatedString + " - " + date.add(duration, "seconds").format("LT");
};
